export default {"src":"/pro/_next/static/media/zro.812def1a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};